import React, { memo } from "react";
import { Route, Routes } from "react-router-dom";
import { routesName } from "core";
import { AddChannel } from "./addChannel";
import { ChannelsList } from "./channelsList";
import { EditChannel } from "./editChannel";
import { ChannelDetail } from "./channelDetail";

const Channels = memo(() => {
  return (
    <Routes>
      <Route path={routesName.ADDCHANNEL} element={<AddChannel />} />
      <Route path={routesName.CHANNELSLIST} element={<ChannelsList />} />
      <Route path={routesName.EDITCHANNEL} element={<EditChannel />} />
      <Route path={routesName.CHANNELDETAIL} element={<ChannelDetail />} />
    </Routes>
  );
});

export { Channels };
